import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { finalize, startWith, tap } from 'rxjs/operators';

interface TAction {
  action: string;
  loading: boolean;
}

@Injectable()
export class ReportLoadingService {
  private individualSubject = new BehaviorSubject<TAction>({
    action: '',
    loading: false,
  });
  individualLoading$: Observable<TAction> =
    this.individualSubject.asObservable();
  private bulkSubject = new BehaviorSubject<TAction>({
    action: '',
    loading: false,
  });
  bulkLoading$: Observable<TAction> = this.bulkSubject.asObservable();

  showIndividualLoading<T>(obs: Observable<T>, action: string): Observable<T> {
    this.individualSubject.next({
      action,
      loading: true,
    });
    return obs.pipe(
      finalize(() =>
        this.individualSubject.next({
          ...this.individualSubject.value,
          loading: false,
        })
      )
    );
  }

  showBlukLoading<T>(obs: Observable<T>, action: string): Observable<T> {
    this.bulkSubject.next({
      action,
      loading: true,
    });
    return obs.pipe(
      finalize(() =>
        this.bulkSubject.next({ ...this.bulkSubject.value, loading: false })
      )
    );
  }
}
